// entityApi.ts
import axios from './axiosSetup3'
import { AxiosRequestConfig } from 'axios';
import { Entity } from "../types/entity";

const get = async (param: {type: number} ): Promise<Entity[]> => {
    const res = await axios.get<Entity[]>(`/lpr_entity?type=eq.${param.type}`);
    return res.data;
};

const getParents = async (param: {type: number} ): Promise<Entity[]> => {
    const res = await axios.get<Entity[]>(`/lpr_entity?type=eq.${param.type}`);
    return res.data;
};

const delete_ = async (entity_id: number): Promise<void> => {
    await axios.delete<Entity>(`/lpr_entity?entity_id=eq.${entity_id}`);
}
const post = async (data: Entity): Promise<Entity> => {
    const { entity_id: omit, ...entity } = data;
    const config: AxiosRequestConfig = {
        headers: {
            'Prefer': 'return=representation'
        }
    };    
    
    const res = await axios.post<Entity>('/lpr_entity', entity, config);

    if (res.status !== 201) return {} as Entity;

    const createdEntity = Array.isArray(res.data) ? res.data[0] : res.data;

    if (!createdEntity || !createdEntity.entity_id) {
        // Дополнительная проверка на случай, если тело ответа все равно пустое
        return {} as Entity; 
    }
    
    return createdEntity;    
}

const put = async (data: Entity): Promise<Entity> => {
    const res = await axios.put<Entity>(`/lpr_entity?entity_id=eq.${data.entity_id}`, data);
    return res.status === 204 ? data : {} as Entity;
}

export const api = {
    get,
    getParents,
    post,
    put,
    delete: delete_,
};